import React from 'react'
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
export default function GroupList() {

    const [searchData, setsearchData] = useState('');
    const [items, setItems] = useState([]);
    // const [posts, setPosts] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [loading, setLoading] = useState(false)
    const [delUserGroupList, setdelUserGroupList] = useState('');
    const [isChecked, setisChecked] = useState(false);
    // const [sorting, setSorting] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [viewMoreData, setviewMoreData] = useState([]);
    const [sortToggle, setSortToggle] = useState(true);
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE)
    // let perPage = 2;
    // let currentPage="";
    useEffect(() => {
        const getGroupList = async () => {
            const res = await Axios.get(`api/admin/list-group?pageNo=1&perPage=${perPage}`)
            console.log(res)
            setItems(res.data.data.data);
            // console.log(res.data.data.data);
            // setFilterData(res.data.data.data)
            setTotalPage(res.data.data.totalPage)
            setpageCount(Math.ceil(res.data.data.totalPage));
            setLoading(false)
            // setItems(posts);
        };
        getGroupList();
    }, [perPage]);

    if (loading && items.length === 0) {
        return <h2>Loading...</h2>
    }
    const fetchGroupList = async (currentPage) => {
        const sort_key = localStorage.getItem('sort_key');
        const sort_order = localStorage.getItem('sort_order');
        let sortUrl = "";
        if (sort_key && sort_order) {
            sortUrl = `&sortkey=${sort_key}&order=${sort_order}`;
        }
        const res = await Axios.get(`api/admin/list-group?pageNo=${currentPage}&perPage=${perPage}${sortUrl}`)
        // console.log(res)

        await setItems(res.data.data.data);


        return items;
    };

    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        const searchBy = document.getElementById("search_by_id").value;
        if(searchData !== "" && searchBy !== ""){

            await searchHandle(currentPage);

        }else{

            await fetchGroupList(currentPage);
    }
        
    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((GroupList) => {
                return { ...GroupList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((GroupList) =>
                GroupList.group_id === name ? { ...GroupList, isChecked: checked } : GroupList
            );
            // console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }
    const alldelete = async (e) => {

        const group_status = e.target.value
        let UserGroupDataLength = isChecked.length;
        let GroupIdArray = [];
        if (UserGroupDataLength >= 0) {
            for (let i = 0; i < UserGroupDataLength; i++) {
                console.log(isChecked[i]);
                if (isChecked[i].isChecked === true) {
                    let GroupID = isChecked[i].group_id;
                    GroupIdArray.push({ group_id: GroupID });
                }
            }
        }

        if (isChecked) {
            const res = await Axios.post(`api/admin/update-user-group-status`, { group_id: GroupIdArray, action_status: group_status });
            console.log(res.data.data);
            setdelUserGroupList(res.data.data)
            console.log(delUserGroupList);
            setNotify({
                isOpen: true,
                messsage: `User Group has been ${group_status} successfully!`,
                type: 'success',

            })
            window.location.reload(false);

        }
        else {
            alert("please Select at least one check box !");
            //console.log("hii");
        }
    }


    const searchHandle = async (currentPage) => {
        alert("hii")
        const searchBy =  document.getElementById("search_by_id").value;
        if(searchData !== "" && searchBy !== "") {
            const res = await Axios.get(`api/admin/list-group?pageNo=${currentPage}&perPage=${perPage}&searchData=${searchData}&search_by=${searchBy}`)
            console.log("Abhay",res);
            
            if(res.data.data.data.length>0){
                setItems(res.data.data.data)
                 setTotalPage(res.data.data.totalPage)
               setpageCount(Math.ceil(res.data.data.totalPage));
            } 
            if(res.data.data.data.length<=0){
                setItems([])
                setTotalPage(res.data.data.totalPage)
                setpageCount(Math.ceil(res.data.data.totalPage));
            }

        } else {
            setNotify({
                isOpen: true,
                messsage: `Search By and Search Value Should Not Be Blank!`,
                type: 'error',

            })
        }

    }



    const handleSortdesc = async (sortkey, order) => {
        if (sortkey) {
            // alert('I am Decending')
            console.log(sortkey)
            setSortToggle(true);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/admin/list-group?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)

            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);


                // setSortToggle(true);
            }
        }
    }

    const handleSortasc = async (sortkey, order) => {
        if (sortkey) {
            console.log(sortkey)
            // alert('I am accending')
            setSortToggle(false);
            localStorage.setItem("sort_key", sortkey)
            localStorage.setItem("sort_order", order)
            const res = await Axios.get(`api/admin/list-group?pageNo=1&perPage=${perPage}&sortkey=${sortkey}&order=${order}`)
            if (res.data.data.data.length > 0) {
                setItems(res.data.data.data);



            }
        }
    }
    const viewMore = async (group_id) => {
        alert('hii');
        const status = group_id;
        console.log('hii', status);
        const res = await Axios.get(`api/admin/list-group?group_id=${group_id}`)
        setviewMoreData(res.data.data.data[0])
        console.log(res.data.data.data[0]);
    }
    return (
        <>
            <div className="content-page">
                <div className="content">
                    
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    {/* <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Techzoni</a></li>
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                        <li className="breadcrumb-item active">Datatable</li>
                                    </ol>
                                </div> */}
                                    <h4 className="page-title">User Group List</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                        <div className="col-md-6">
                                <div className="business_head">
                                    <button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="business_head">
                                    {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }         <span><b>Search By :- </b></span>
                                    <select name="search_by" id="search_by_id">
                                        <option value="">Select</option>
                                        <option value="business_id">Business ID</option>
                                        <option value="business_name">Business Name</option>
                                        <option value="business_mobile_no">Business mobile No</option>
                                        <option value="business_email_id">Business Email Id</option>

                                    </select>

                                    <input type="" className='search-business-list' placeholder='Search...'
                                        onChange={(e) => setsearchData(e.target.value)}
                                    />
                                    <button type="Search" className="find-list" onClick={searchHandle}>Search</button>
                                </div>

                            </div>
                            <div className="col-12">
                                <div className="tble-row table-responsive">

                                    {/* <button className="btn btn-danger" type="button" value="Deleted" onClick={(e) => alldelete(e)} >DELETE</button>&nbsp;&nbsp;&nbsp;
                                    <button className="btn btn-primary" type="button" value="Active" onClick={(e) => alldelete(e)}  >Active All</button>&nbsp;&nbsp;&nbsp;
                                    <button className="btn btn-primary" type="button" value="Inactive" onClick={(e) => alldelete(e)}>Inactive All</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }
                                    <span><b>Search By:-</b></span>
                                    <select name="search_by" id="search_by_id">
                                        <option value="">Select</option>
                                        <option value="group_id">Group ID</option>
                                        <option value="group_name">Group Name</option>
                                        <option value="business_id">Business ID</option>
                                        <option value="business_name">Business Name</option>

                                    </select>&nbsp;&nbsp;&nbsp;
                                    <input type="" className='search-User-Group-list' placeholder='Search...'
                                        onChange={(e) => setsearchData(e.target.value)}
                                    />
                                    <button type="Search" onClick={searchHandle}>Search</button> */}


                                    <table id="datatable" className="table table-bordered  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <th><input
                                                    type="checkbox"

                                                    name="allSelect"
                                                    checked={!items.some((GroupList) => GroupList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label>
                                                    </th>

                                                <th>S.No</th>
                                                <th >Group ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("group_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("group_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Group Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("group_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("group_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Business ID
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_id", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_id", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Business Name
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("business_name", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("business_name", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th > Group Description

                                                </th>
                                                {/* <td >Modified Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("modified_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("modified_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </td> */}
                                                <th >Added Date
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("added_date", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("added_date", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Date Time Stamp
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("date_time_stamp", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("date_time_stamp", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Added By

                                                </th>
                                                <th >Group Status
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("group_status", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("group_status", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                                <th >Number Of User
                                                    {sortToggle ? (
                                                        <i onClick={() => handleSortasc("no_of_user", 'asc')} className="fa fa-arrow-up" style={{ fontSize: "10px" }}></i>
                                                    ) : (
                                                        <i onClick={() => handleSortdesc("no_of_user", 'desc')} className="fa fa-arrow-down" style={{ fontSize: "10px" }}></i>
                                                    )}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((GroupList, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[GroupList.group_id]}
                                                        checked={GroupList?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{GroupList.group_id}</td>
                                                    <td>{GroupList.group_name}</td>
                                                    <td>{GroupList.business_id}</td>
                                                    <td>{GroupList.business_name}</td>
                                                    <td>{GroupList.group_description}</td>
                                                    <td>{GroupList.added_date}</td>
                                                    <td>{GroupList.date_time_stamp}</td>
                                                    <td>{GroupList.added_by}</td>
                                                    <td>{GroupList.group_status}</td>
                                                    <td>{GroupList.no_of_user}</td>
                                                    <td><button
                                                        type="button" className="btn btn-primary"
                                                        data-toggle="modal"
                                                        data-target="#exampleModalCenter"
                                                        value={GroupList.group_id}
                                                        onClick={(e) => viewMore(e.target.value)}
                                                    >
                                                        View More</button></td>
                                                </tr>)}
                                        </tbody>
                                    </table>
                                    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">GROUP LIST</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-md-6 col-lg-6 col-xl-6">
                                                                <p><strong>S.No:-</strong></p>
                                                                <p><strong>group_id:-{viewMoreData.group_id}</strong></p>
                                                                <p><strong>group_name:-{viewMoreData.group_name}</strong></p>
                                                                <p><strong>business_id:-{viewMoreData.business_id}</strong></p>
                                                                <p><strong>business_name:-{viewMoreData.business_name}</strong></p>
                                                                <p><strong>group_description:-{viewMoreData.group_description}</strong></p>
                                                                
                                                            </div>

                                                            <div className="col-md-6 col-lg-6 col-xl-6">

                                                                <p><strong>added_date:-{viewMoreData.added_date}</strong></p>
                                                                <p><strong>date_time_stamp:-{viewMoreData.date_time_stamp}</strong></p>
                                                                <p><strong>added_by:-{viewMoreData.added_by}</strong></p>
                                                                <p><strong>group_status:-{viewMoreData.group_status}</strong></p>
                                                                <p><strong>no_of_user:-{viewMoreData.no_of_user}</strong></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                                    <button type="button" className="btn btn-primary">Save changes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div className='slect-pg-row'>
                                        <span><b>Rows per page:-</b></span>
                                        <select name="Rows per page" className="item-page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>
        </>
    )
}
